import React, { useState, useEffect } from "react";
import axios from "axios";
import { apiUrl } from "../config/url";
import Navbar from "./Navbar";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [editUserId, setEditUserId] = useState(null);
  const [editUserData, setEditUserData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserList = async () => {
      const token = localStorage.getItem("api_token"); // Get API token from localStorage
      try {
        const response = await axios.get(`${apiUrl}/admin/userList`, {
          headers: { api_token: token }, // Add token to headers
        });
        setUsers(response.data.data); // Set user data to state
      } catch (error) {
        console.error("There was an error fetching the user data!", error);
        setError("Failed to fetch user data. Please try again.");
        toast.error("Failed to fetch user data. Please try again.");
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };

    fetchUserList(); // Call the async function
  }, []); // Empty dependency array ensures it runs once on mount

  const handleEditClick = (user) => {
    setEditUserId(user.id);
    setEditUserData(user);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditUserData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSaveClick = async () => {
    const token = localStorage.getItem("api_token"); // Get API token from localStorage

    // Basic validation
    if (!editUserData.username || !editUserData.full_name || !editUserData.mob_no) {
      toast.error("Please fill all required fields!");
      return;
    }

    try {

        console.log(editUserData);
        
      const response = await axios.post(`${apiUrl}/admin/updateUserDirect`, editUserData, {
        headers: { api_token: token }, // Include api_token in the headers
      });

      if (response.data.status) { // Check the response status
        toast.success("User details updated successfully!"); // Show success toast
      } else {
        toast.error("User detail updation unsuccessful!"); // Show error toast
      }

      // Refresh the user list after update
      const userListResponse = await axios.get(`${apiUrl}/admin/userList`, {
        headers: { api_token: token }, // Include api_token in the headers
      });
      setUsers(userListResponse.data.data); // Update the user list
      setEditUserId(null); // Reset edit mode
    } catch (error) {
      console.error('There was an error updating the user data!', error);
      toast.error("User detail updation unsuccessful!"); // Show error toast
    }
  };

  return (
    <>
      <Navbar />
      <ToastContainer />
      <div className="container mx-auto p-6">
        <h1 className="text-2xl font-bold mb-4">User List</h1>
        {loading ? (
          <p>Loading...</p> // Loading state message
        ) : error ? (
          <p className="text-red-500">{error}</p> // Error message display
        ) : (
          <>
            <table className="table-auto w-full text-left">
              <thead>
                <tr>
                  <th className="px-4 py-2">User ID</th>
                  <th className="px-4 py-2">Username</th>
                  <th className="px-4 py-2">Full Name</th>
                  <th className="px-4 py-2">Mobile No</th>
                  <th className="px-4 py-2">Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user) => (
                  <tr key={user.id}>
                    <td className="border px-4 py-2">{user.id}</td>
                    <td className="border px-4 py-2">{user.username}</td>
                    <td className="border px-4 py-2">{user.full_name}</td>
                    <td className="border px-4 py-2">{user.mob_no}</td>
                    <td className="border px-4 py-2">
                      <button
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mr-2"
                        onClick={() => handleEditClick(user)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {editUserId && (
              <div className="mt-6">
                <h2 className="text-xl font-bold mb-2">Edit User</h2>
                <label className="block mb-2">
                  User ID:
                  <input
                    type="text"
                    name="user_id"
                    value={editUserData.id}
                    readOnly
                    className="block w-full px-3 py-2 mt-1 border rounded-md bg-gray-200"
                  />
                </label>
                <label className="block mb-2">
                  Username:
                  <input
                    type="text"
                    name="username"
                    value={editUserData.username}
                    onChange={handleInputChange}
                    className="block w-full px-3 py-2 mt-1 border rounded-md"
                  />
                </label>
                <label className="block mb-2">
                  Full Name:
                  <input
                    type="text"
                    name="full_name"
                    value={editUserData.full_name}
                    onChange={handleInputChange}
                    className="block w-full px-3 py-2 mt-1 border rounded-md"
                  />
                </label>
                <label className="block mb-2">
                  Mobile No:
                  <input
                    type="text"
                    name="mob_no"
                    value={editUserData.mob_no}
                    onChange={handleInputChange}
                    className="block w-full px-3 py-2 mt-1 border rounded-md"
                  />
                </label>
                <label className="block mb-2">
                  Password:
                  <input
                    type="password"
                    name="new_password"
                    value={editUserData.new_password || ""}
                    onChange={handleInputChange}
                    className="block w-full px-3 py-2 mt-1 border rounded-md"
                  />
                </label>
                <button
                  className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded mt-4"
                  onClick={handleSaveClick}
                >
                  Save
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default UserList;
